const config = () => ({
  apiURL: "https://internship-s23.cloudflare-general-assignment.workers.dev",
});
export default config();